import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
  LEAD_STATUS_LEASE_SIGNED,
  LEAD_STATUS_ARCHIVED,
  LEAD_STATUS_ASSIGNED,
  LEAD_STEP_STATUS_LIST,
  getLeadStatusLabel,
} from 'common/leadConstants';

import SrLink from 'client/components/SrLink/SrLink';
import ButtonDeprecated, {
  BUTTON_THEME_BLUE,
  BUTTON_THEME_DARK_GRAY,
} from 'client/components/ButtonDeprecated';

import ApartmentLocatorAction from 'client/actions/ApartmentLocator';

import { formatPhoneNumber, getAutoTextStatus } from 'common/formatters';

function getNextLeadStatus(currentLeadStatus) {
  const leadStatusIndex = LEAD_STEP_STATUS_LIST.indexOf(currentLeadStatus);
  if (LEAD_STEP_STATUS_LIST[leadStatusIndex + 1] === LEAD_STATUS_ARCHIVED) {
    return null;
  }

  return LEAD_STEP_STATUS_LIST[leadStatusIndex + 1];
}

class SrAgentLeadsListRow extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    lead: PropTypes.object.isRequired,
    reloadTable: PropTypes.func.isRequired,
    isRemoved: PropTypes.bool.isRequired,
    isAdded: PropTypes.bool.isRequired,
    showPhoneNumber: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
  };

  _onMarkLead = (e) => {
    const { lead, dispatch, reloadTable, history } = this.props;

    e.stopPropagation();
    e.preventDefault();

    const toLeadStatus =
      lead.status === LEAD_STATUS_ARCHIVED ? LEAD_STATUS_ASSIGNED : getNextLeadStatus(lead.status);

    if (toLeadStatus === LEAD_STATUS_LEASE_SIGNED) {
      history.push(`/agent/lead/${lead.renterUserId}?scrollTo=leaseForm`);
    } else {
      dispatch(ApartmentLocatorAction.updateLeadStatus, {
        apartmentLocatorUserId: lead.apartmentLocatorUserId,
        renterUserId: lead.renterUserId,
        fromLeadStatus: lead.status,
        toLeadStatus: toLeadStatus,
      }).then(() => {
        if (lead.status === LEAD_STATUS_ARCHIVED) {
          reloadTable({ renterUserId: lead.renterUserId, showPositiveFeedbackModal: false });
          history.push('/agent/leads/assigned');
        } else {
          reloadTable({ renterUserId: lead.renterUserId, showPositiveFeedbackModal: true });
        }
      });
    }
  };

  _getActionButtonTitle = ({ isRemoved, status, nextLeadStatus }) => {
    if (status === LEAD_STATUS_ARCHIVED) {
      return 'un-archive';
    }

    return `mark ${
      isRemoved
        ? getLeadStatusLabel({ leadStatus: status, isSingular: true })
        : getLeadStatusLabel({ leadStatus: nextLeadStatus, isSingular: true })
    }`;
  };

  render() {
    const { lead, isRemoved, isAdded, showPhoneNumber } = this.props;
    const { renterActivity, status, frontAutoText } = lead;
    const nextLeadStatus = getNextLeadStatus(status);
    const autoTextStatus = getAutoTextStatus({ renterActivity, frontAutoText });

    return (
      <div
        className={classnames(
          'rowContainer',
          {
            searching: showPhoneNumber,
            archived: status === LEAD_STATUS_ARCHIVED,
          },
          {
            isAdded: isAdded,
          },
        )}
      >
        <SrLink
          to={`/agent/lead/${lead.renterUserId}`}
          className={classnames({
            expandedRow: !!autoTextStatus && status !== LEAD_STATUS_ARCHIVED,
          })}
        >
          <div className="mainItems">
            <div className="textContainer">
              <span className="mainText">{lead.renter.name}</span>
              {showPhoneNumber && (
                <span className="phoneNumber">{formatPhoneNumber(lead.renter.phone)}</span>
              )}
            </div>
            {autoTextStatus && status !== LEAD_STATUS_ARCHIVED && (
              <div className="secondaryContainer">
                <span className="autoText">Autotext: {autoTextStatus}</span>
              </div>
            )}
          </div>
          {(nextLeadStatus || isRemoved || status === LEAD_STATUS_ARCHIVED) && (
            <ButtonDeprecated
              className={classnames({
                [`extra-small ${nextLeadStatus}`]: status !== LEAD_STATUS_ARCHIVED,
                'extra-small archived': status === LEAD_STATUS_ARCHIVED,
              })}
              theme={status === LEAD_STATUS_ARCHIVED ? BUTTON_THEME_DARK_GRAY : BUTTON_THEME_BLUE}
              onClick={this._onMarkLead}
              disabled={isRemoved}
            >
              {this._getActionButtonTitle({ isRemoved, status, nextLeadStatus })}
            </ButtonDeprecated>
          )}
        </SrLink>
      </div>
    );
  }
}

SrAgentLeadsListRow.displayName = 'SrAgentLeadsListRow';

export default SrAgentLeadsListRow;
